import { Controller } from "stimulus"
import { FetchRequest, get } from '@rails/request.js'

export default class extends Controller {
  static targets = ["questionForm", "questionsWrapper", "addQuestion", "optionFormTemplate", "questionsListWrapper"]
  connect() {
    // console.log('connected to questionnaire controller')
  }

  async saveQuestion(e) {
    e.preventDefault()
    // console.log('save', e.currentTarget)
    const form = e.currentTarget
    // console.log('submit button', form.submit)
    // const submitBtn = form.querySelector("input[type='submit']")
    // const formWrapper = form.parentNode.parentNode
    // console.log('wrapp', formWrapper)
    const formData = new FormData(form)
    const req = new FetchRequest(form.method, form.action + '?format=json', { body: formData })
    const response = await req.perform()
    // console.log('response', response)
    // console.log('response.status', response.statusCode)
    if (response.statusCode === 200) {
      // const body = await response.json
      // if saved remove the form wrapper
      // this.element.querySelector('#question-form-wrapper').remove()
      window.location.reload()
    } else {
      // console.log('error')
      const body = await response.json
      // console.log('body', body)
      if (body.element) {
        this.element.querySelector('#question-form-wrapper').outerHTML = body.element
      }
    }
  }

  closeQuestionFormModal(e) {
    // console.log('closeQuestionFormModal', e.currentTarget)
    document.getElementById('question-form-wrapper').remove()
  }

  async editQuestion(e) {
    // console.log('editQuestion', e.currentTarget)
    const questionId = e.currentTarget.dataset.questionId
    const res = await get(`/admin/questions/${questionId}/edit?format=json`)
    const data = await res.json
    // console.log('data', data)
    if (data.element) {
      this.element.insertAdjacentHTML('afterbegin', data.element)
    }
  }

  async addQuestion(e) {
    // console.log('questionnaireId', e.currentTarget.dataset.questionnaireId)
    const questionnaireId = e.currentTarget.dataset.questionnaireId
    const res = await get(`/admin/questionnaires/${questionnaireId}/questions/new?format=json`)
    const data = await res.json
    // console.log('data', data)
    if (data.element) {
      this.element.insertAdjacentHTML('afterbegin', data.element)
    }
  }

  async reorderQuestion(e) {
    // console.log('reorderQuestion', e.currentTarget)
    const questionId = e.currentTarget.dataset.questionId
    const direction = e.currentTarget.dataset.direction
    const res = await get(`/admin/questions/${questionId}/reorder_question?direction=${direction}&format=json`)
    const data = await res.json
    // console.log('data', data)
    if (data.partial) {
      this.questionsListWrapperTarget.outerHTML = data.partial
    }
  }
}


